import { createSlice } from '@reduxjs/toolkit';
import { editMyAccountsThunk, getMyAccountsThunk, saveMyAccountsThunk } from './myAccountsActions';

export interface MyAccountsData {
  loading: boolean;
  data: any[];
}

const initialState: MyAccountsData = {
  loading: false,
  data: null,
};

const myAccountsSlice = createSlice({
  name: 'My Accounts',
  initialState,
  reducers: {
    clearAccountsData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMyAccountsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMyAccountsThunk.fulfilled, (state, action) => {
        state.data = action.payload?.data?.allAccounts || [];
        state.loading = false;
      })
      .addCase(getMyAccountsThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(saveMyAccountsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveMyAccountsThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(saveMyAccountsThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(editMyAccountsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(editMyAccountsThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(editMyAccountsThunk.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { clearAccountsData } = myAccountsSlice.actions;
export default myAccountsSlice.reducer;
